<app-feature-hero
    title="Asset Tracking Solution"
    description="Optimize asset utilization and performance with Infraon’s asset tracking solution."
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/it-lifecycle-hero-img-01-01-01.svg"
    imageAlt="IT Lifecycle Management Hero Image"
></app-feature-hero>

<app-feature-row
    headingLevel="h2"
    heading="What Is Asset Tracking?"
    [paragraphs]="overviewParagraphs"
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-1.webp"
    imageAlt="hardware asset management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Infraon’s Asset Tracking Solution"
    [paragraphs]="solutionParagraphs"
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-2.webp"
    imageAlt="Asset performance"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div
        class="ai-based-itsm depreciation-calculator case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Asset Depreciation Confusing You? <br />
                Our Calculator Can Help!
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Improve your financial management with razor-sharp asset depreciation <br /> metrics – always make
                decisions based on solid data.
            </p>

            <a routerLink="/free-tools/asset-depreciation-calculator/" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Calculate</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                    <path
                        d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
                        fill="#1A5AD9" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="key-features container section-spacing">
    <h2 class="section-title p-lr-60 p-b-60">
        Key Features of Infraon’s <br />
        Asset Tracking
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="25" viewBox="0 0 33 25" fill="none">
                    <rect x="4" y="3" width="26" height="19" fill="#A8C1F1" />
                    <path
                        d="M32.25 0.25V24.75H0.75V0.25H32.25ZM8.625 5.5H6V19.5H8.625V5.5ZM10.375 5.5V19.5H12.125V5.5H10.375ZM16.5 5.5H13.875V19.5H16.5V5.5ZM20 5.5V19.5H22.625V5.5H20ZM27 5.5H25.25V19.5H27V5.5Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Asset Lifecycle Tracking
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Track assets throughout their lifecycles with a full view of all
                    assets, as well as their location and status. Use asset tagging,
                    barcode/ QR code scanning, GPS tracking, etc.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
                    <path
                        d="M19.625 2.25781L19.5703 2.20312C19.2969 1.98438 18.6953 1.60156 17.7656 1.27344C15.9062 0.617188 13.1172 0.125 10 0.125C6.82812 0.125 4.03906 0.617188 2.17969 1.27344C1.25 1.60156 0.648438 1.98438 0.375 2.20312V2.25781V7.07031C1.08594 7.45312 2.07031 7.83594 3.32812 8.16406C5.1875 8.60156 7.48438 8.875 10 8.875C12.4609 8.875 14.7578 8.60156 16.6172 8.16406C17.875 7.83594 18.8594 7.45312 19.625 7.07031V2.25781ZM19.625 9.96875C18.8594 10.2422 18.0938 10.5156 17.2188 10.7344C15.1406 11.2266 12.625 11.5 10 11.5C7.32031 11.5 4.80469 11.2266 2.72656 10.7344C1.85156 10.5156 1.08594 10.2422 0.375 9.96875V14.0703C1.08594 14.4531 2.07031 14.8359 3.32812 15.1641C5.1875 15.6016 7.48438 15.875 10 15.875C12.4609 15.875 14.7578 15.6016 16.6172 15.1641C17.875 14.8359 18.8594 14.4531 19.625 14.0703V9.96875ZM0.265625 2.3125C0.210938 2.36719 0.210938 2.36719 0.210938 2.36719L0.265625 2.3125ZM19.7344 2.36719C19.7344 2.36719 19.7344 2.36719 19.6797 2.3125L19.7344 2.36719Z"
                        fill="#084CD4" />
                    <path
                        d="M0.164062 20.8828C0.4375 21.1016 1.03906 21.4844 1.96875 21.8125C3.82812 22.4688 6.61719 22.9062 9.73438 22.9062C12.9062 22.9062 15.6953 22.4688 17.5547 21.8125C18.4844 21.4844 19.0859 21.1016 19.3594 20.8828L19.4141 20.8281V17C18.6484 17.2734 17.8828 17.5469 17.0078 17.7656C14.9297 18.2578 12.4141 18.5312 9.73438 18.5312C7.10938 18.5312 4.59375 18.2578 2.51562 17.7656C1.64062 17.5469 0.875 17.2734 0.109375 17V20.8281L0.164062 20.8828ZM19.5234 20.7188L19.4688 20.7734C19.5234 20.7188 19.5234 20.7188 19.5234 20.7188ZM0.0546875 20.7734C0.0546875 20.7188 0 20.7188 0 20.7188L0.0546875 20.7734Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Centralized Asset Database
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Store asset information, including location, status, and history,
                    in a centralized database. Access information from any
                    internet-connected device anywhere.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                    <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
                    <path
                        d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
                        fill="#084CD4" />
                    <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Automated Asset Discovery
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Use QR codes to track assets and display the asset's location and
                    other information in real time. Enable users to view asset
                    information, location, and status.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                    <path
                        d="M12.75 8.375C12.75 4.05469 16.25 0.5 20.625 0.5C21.6641 0.5 22.6484 0.71875 23.5234 1.10156L18.875 5.75V10.125H23.25L27.8984 5.47656C28.2812 6.35156 28.5 7.33594 28.5 8.375C28.5 11.7656 26.3672 14.6094 23.4141 15.7578L20.9531 13.2969L19.75 12.0391L18.4922 13.2969L18.0547 13.7344L12.75 8.42969V8.375ZM0.5 23.25L9.6875 14.0625L13.6797 18.0547L13.2422 18.5469L11.9844 19.75L13.2422 21.0078L5.75 28.5L0.5 23.25ZM7.99219 22.8125L6.1875 21.0078L4.32812 22.8125L6.1875 24.6719L7.99219 22.8125Z"
                        fill="#084CD4" />
                    <path
                        d="M16.6953 18.5547L9.64062 11.5H6.25L1 4.5L4.5 1L11.5 6.25V9.69531L18.5547 16.6953L20.25 15L29 23.75L23.75 29L15 20.25L16.6953 18.5547Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Customizable Asset Fields
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Create custom asset fields to improve your asset management
                    processes. Track and view specific assets by setting up alerts on
                    status changes.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                    <path
                        d="M3 11.5C3 11.2239 3.22386 11 3.5 11H17.5C17.7761 11 18 11.2239 18 11.5V11.5C18 11.7761 17.7761 12 17.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11.5Z"
                        fill="white" />
                    <path
                        d="M3 17.5C3 17.2239 3.22386 17 3.5 17H17.5C17.7761 17 18 17.2239 18 17.5V17.5C18 17.7761 17.7761 18 17.5 18H3.5C3.22386 18 3 17.7761 3 17.5V17.5Z"
                        fill="white" />
                    <path
                        d="M3 23.5C3 23.2239 3.22386 23 3.5 23H17.5C17.7761 23 18 23.2239 18 23.5V23.5C18 23.7761 17.7761 24 17.5 24H3.5C3.22386 24 3 23.7761 3 23.5V23.5Z"
                        fill="white" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Software License Tracking
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Use automation to help asset managers track end-user license
                    agreements. Provide an interactive dashboard to discover installed
                    software.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Custom Asset Reporting
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Generate reports on your assets with real-time visibility into
                    assets. Manage asset lifecycles and reduce costs, ensuring higher
                    ROI.
                </p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Other Features of Infraon’s Asset Tracking"
    listStyle="check"
    checkIconSize="lg"
    [listItems]="otherFeaturesItems"
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-3.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div class="ai-based-itsm ebook d-flex align-items-center justify-content-between position-relative">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Upcoming Trends in IT Asset Management for 2024
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Stay abreast of the newest trends in IT asset management and equip <br /> your organization for future
                challenges.
            </p>

            <a [routerLink]="['/resources/', 'press-n-medias', 'itops-technology-trends-2023']" class="crmform-button">
                <span class="me-1">Download our e-book</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0d51d9" />
                </svg>
            </a>
        </div>
        <img src="/assets/img/feature-pages/asset-management-ebook.webp" class="asset-mmanagement-ebook m-d-none"
            alt="asset mmanagement ebook" />
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">
        Why Use Infraon’s IT Asset <br />
        Management Solution
    </h2>

    <app-feature-row
        headingLevel="h3"
        heading="Improved Asset Management"
        [paragraphs]="improvedMgmtParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/qr-code-feature-img-2-01.png"
        imageAlt="Device discovery charts"
        imagePosition="right"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Increased Asset Visibility"
        [paragraphs]="increasedVisibilityParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-verification-feature-7-01.png"
        imageAlt="Asset verification feature."
        imagePosition="left"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Automated Compliance"
        [paragraphs]="automatedComplianceParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/qr-code-feature-img-6-01.png"
        imageAlt="Device Availability"
        imagePosition="right"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Reduced Operational Costs"
        [paragraphs]="reducedCostsParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/qr-code-feature-img-3-01.png"
        imageAlt="Maintenance cost"
        imagePosition="left"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Enhanced Security"
        [paragraphs]="enhancedSecurityParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-6.webp"
        imageAlt="Shield Illurtation"
        imagePosition="right"
    ></app-feature-row>

    <app-feature-row
        headingLevel="h3"
        heading="Better Decision-Making"
        [paragraphs]="betterDecisionParagraph"
        image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-7.webp"
        imageAlt="All device report"
        imagePosition="left"
    ></app-feature-row>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">CASE STUDY</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                How Our Leading Asset
                Management Software Helped a <br />
                Top IT Consulting Company
            </h2>
            <div class="case-study-pointers">
                <div>
                    <span></span>
                    <span>75% increase in asset efficiency</span>
                </div>
                <div>
                    <span></span>
                    <span>50%-75% reduction in asset costs</span>
                </div>
                <div>
                    <span></span>
                    <span>75% higher asset compliance</span>
                </div>
            </div>

            <a [routerLink]="['/resources/', 'case-studies', 'tcs-passport-seva-project']" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Download Case-study</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#1A5AD9" />
                </svg>
            </a>
        </div>
        <div>
            <img src="/assets/img/feature-pages/case-study-illustration.webp" class="case-study-illustration m-d-none"
                alt="Case Study Illurtation" />
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Best Practices for Managing IT Assets"
    [paragraphs]="bestPracticesParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="bestPracticesItems"
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-4.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Benefits of IT Asset Management"
    [paragraphs]="benefitsParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="benefitsItems"
    image="/assets/img/feature-pages/infraon-assets/asset-tracking-software/asset-tracking-feature-5.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="right"
></app-feature-row>
<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">
                        <strong>IT asset management</strong>
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">
                        <strong>Software asset management</strong>
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-license-management">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">
                        <strong>Software Licensing management</strong>
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon Assets helps you manage the lifecycles of fixed assets
                        like PCs, laptops, furniture, storage devices, etc., with a
                        360-degree view...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>